module.exports = __webpack_public_path__ + "static/img/djkx6.e447152.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/djkx6.jpeg
// module id = 3/c0
// module chunks = 1